// NOTE: Below capabilities are not present in TMS, thus guarding routes to access by ELMO ADMINS only
// eslint-disable-next-line no-shadow
export enum AllAccessPermission {
  ACCESS_ALLOW_ALL = 'admin.coursebuilder.access.all',
}
